import * as React from "react"
import { ChevronDownIcon } from "@/components/ds/icons"

import { cn } from "@/lib/utils"

function NativeSelect({
  className,
  wrapperClassName,
  size = "default",
  ...props
}: Omit<React.ComponentProps<"select">, "size"> & {
  size?: "sm" | "default"
  /** El envoltorio mide lo que mide el `<select>` (`w-fit`), que es lo que
   *  quiere un filtro de toolbar. Pasá `w-full` acá — no en `className`, que
   *  va al `<select>` y queda encerrado por el envoltorio — cuando el control
   *  tenga que llenar la columna de un formulario. */
  wrapperClassName?: string
}) {
  return (
    <div
      className={cn(
        "group/native-select relative w-fit has-[select:disabled]:opacity-50",
        wrapperClassName
      )}
      data-slot="native-select-wrapper"
    >
      <select
        data-slot="native-select"
        data-size={size}
        className={cn(
          "border-input bg-background placeholder:text-soft selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 appearance-none rounded-lg border px-[9px] pr-9 text-[12.5px] transition-colors outline-none disabled:pointer-events-none disabled:cursor-not-allowed data-[size=sm]:h-[34px]",
          "hover:border-border-strong",
          "focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring",
          "aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
      <ChevronDownIcon
        className="text-soft pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  )
}

function NativeSelectOption({ ...props }: React.ComponentProps<"option">) {
  return <option data-slot="native-select-option" {...props} />
}

function NativeSelectOptGroup({
  className,
  ...props
}: React.ComponentProps<"optgroup">) {
  return (
    <optgroup
      data-slot="native-select-optgroup"
      className={cn(className)}
      {...props}
    />
  )
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption }
